import { Section } from 'components/section'

export const Intro = () => (
  <Section containerType="text">
    <p>
      В странах Центральной Азии законы, которые должны защищать от насилия, не
      всегда эффективны, а многие случаи не доходят до суда. Даже если женщина
      подает заявление, насильник зачастую остается безнаказанным. В последние
      два года в Казахстане и Узбекистане домашнее насилие стало уголовным
      преступлением.{' '}
    </p>
    <p>
      Официальные данные отражают проблему поверхностно: из-за патриархальных
      норм общества, стигмы и недоверия к милиции обо многих случаях не
      сообщают, и они не попадают в статистику. Из-за этого очень сложно оценить
      реальный масштаб проблемы.{' '}
    </p>
    <p>
      Проект "Голоса смелых" исследует проблему гендерного насилия в странах
      Центральной Азии. Мы проводим{' '}
      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLSfkrvPhTgjXjwp_N8icQ2PHfcdEmIY7veZPUit-UULl6h6SVA/viewform?fbclid=PAZXh0bgNhZW0CMTEAAaalHVpSI84WLa9huwBHq6J7H6KHOobeBYXraPfY5lFXN8edgm-ci6EvPJI_aem_53dG2_u7MrXFHnY58XCZWQ"
        target="_blank"
        rel="noreferrer"
      >
        опрос
      </a>{' '}
      в странах Центральной Азии, рассказываем о проблеме в{' '}
      <a
        href="https://www.instagram.com/voicesofthebrave.ca/"
        target="_blank"
        rel="noreferrer"
      >
        инстаграме
      </a>{' '}
      и на отдельном{' '}
      <a href="https://voicesofthebrave.asia/" target="_blank" rel="noreferrer">
        сайте
      </a>
      , а также собираем и публикуем истории женщин, переживших насилие.
    </p>
    <p>
      Проект посвящен голосам женщин, их внутренней силе и праву на безопасность
      и счастье. Совместно с Настоящим Временем мы рассказываем истории женщин,
      которые смогли уйти от насильников, а также о том, что важно знать о
      домашнем насилии в странах Центральной Азии.
    </p>
  </Section>
)
